import { FiBookmark, FiShoppingCart, FiUser } from "react-icons/fi";

export const menus = [
  {
    link: "/wishlist",
    icon: FiBookmark
  },
  {
    link: "/cart",
    icon: FiShoppingCart
  },

  {
    link: "/user",
    icon: FiUser
  }
];
